<div class="error-page-container">
  <div class="error-content">
    <h1 class="error-code">404</h1>
    <h4 class="error-title" translate>errors.not_found</h4>
    <button pButton type="button" class="p-button-primary" (click)="goToCustomers()" translate>
      buttons.go_to_customers
    </button>
  </div>
</div>
